'use client';
import { Box, useTheme } from '@mui/material';
import ServiceElement from './ServiceElement';
import { useLayoutEffect, useRef, useState } from 'react';
import { AccordionType } from '../type';
import DarkThemeProvider from '../../../../providers/DarkThemeProvider';
import LightThemeProvider from '../../../../providers/LightThemeProvider';

type Props = {
  data: AccordionType;
  isMobile: boolean;
};

const FullHorizontalAccordion = ({ data }: Props) => {
  const { elements, styling } = data;
  const theme = useTheme();
  const [selected, setSelected] = useState(0);
  const [maxHeight, setMaxHeight] = useState<number | 'auto'>('auto');
  const containerRef = useRef<HTMLDivElement>(null);

  useLayoutEffect(() => {
    if (containerRef.current) {
      const currentHeight = containerRef.current.getBoundingClientRect().height;

      setMaxHeight((prevMax) => {
        if (prevMax === 'auto' || currentHeight > prevMax) {
          return currentHeight;
        }
        return prevMax;
      });
    }
  }, [selected]);

  const ThemeProvider = styling.isOpenDark
    ? DarkThemeProvider
    : LightThemeProvider;
  return (
    <ThemeProvider>
      <Box
        ref={containerRef}
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', md: 'row' },
          alignItems: 'stretch',
          justifyContent: 'stretch',
          bgcolor: 'background.paper',
          minHeight: { md: maxHeight, xs: 'auto' },
          ...styling.sx,
        }}
      >
        {elements.map((item, index) => {
          return (
            <ServiceElement
              key={`${item.title}_${index}`}
              title={item.title}
              isOpen={index === selected}
              description={item.description}
              onClick={() => setSelected(index)}
              elementPallet={styling.isDark ? 'dark' : 'light'}
              palletMode={styling.isOpenDark ? 'dark' : 'light'}
            />
          );
        })}
      </Box>
    </ThemeProvider>
  );
};

export default FullHorizontalAccordion;
